import React from 'react'

export const FilterIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 0H8V2H6V4H12V2H10V0Z" fill="#8C8C8C" />
      <path d="M10 5H8V12H10V5Z" fill="#8C8C8C" />
      <path d="M0 10H2V12H4V10H6V8H0V10Z" fill="#8C8C8C" />
      <path d="M4 0H2V7H4V0Z" fill="#8C8C8C" />
    </svg>
  )
}

interface CustomExpandMoreProps {
  size: number
  color: string
}

export const CustomExpandMore = ({ size, color }: CustomExpandMoreProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10.5 8.5L6 4L1.5 8.5" stroke={color} strokeWidth="2" />
    </svg>
  )
}

export const CheckedBox = ({ size, color }: CustomExpandMoreProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 0.5H1.875C0.839466 0.5 0 1.33947 0 2.375V13.625C0 14.6605 0.839466 15.5 1.875 15.5H13.125C14.1605 15.5 15 14.6605 15 13.625V2.375C15 1.33947 14.1605 0.5 13.125 0.5Z"
        fill={color}
      />
      <path
        d="M3.75 7.29618L6.70495 10.3438L11.25 5.65625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  )
}

export const UncheckedBox = ({ size, color }: CustomExpandMoreProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1H13C13.8284 1 14.5 1.67157 14.5 2.5V13.5C14.5 14.3284 13.8284 15 13 15H2C1.17157 15 0.5 14.3284 0.5 13.5V2.5C0.5 1.67157 1.17157 1 2 1Z"
        fill={color}
        stroke="#CBD5E1"
      />
    </svg>
  )
}

export const BreadscrumSeperatorIcon = () => {
  return (
    <svg
      width="5"
      height="8"
      viewBox="0 0 5 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.3"
        d="M4.64212 3.52047L1.30879 0.187141C1.18305 0.0657025 1.01465 -0.00149374 0.839856 2.52017e-05C0.665058 0.00154415 0.497849 0.0716568 0.374244 0.195262C0.250639 0.318868 0.180526 0.486076 0.179007 0.660874C0.177488 0.835672 0.244684 1.00407 0.366123 1.12981L3.22812 3.99181L0.366123 6.85381C0.30245 6.91531 0.251662 6.98887 0.216722 7.0702C0.181783 7.15154 0.163392 7.23902 0.162623 7.32754C0.161854 7.41606 0.178721 7.50385 0.212242 7.58578C0.245763 7.66771 0.295265 7.74214 0.35786 7.80474C0.420455 7.86733 0.494889 7.91683 0.57682 7.95036C0.658751 7.98388 0.746538 8.00074 0.835057 7.99997C0.923577 7.99921 1.01106 7.98081 1.09239 7.94588C1.17373 7.91094 1.24729 7.86015 1.30879 7.79647L4.64212 4.46314C4.7671 4.33812 4.83731 4.16858 4.83731 3.99181C4.83731 3.81503 4.7671 3.64549 4.64212 3.52047Z"
        fill="#1B3963"
      />
    </svg>
  )
}

export const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7124 10.5629H11.2277L15.2932 14.6366L14.6366 15.2932L10.5629 11.2277V10.7124V10.5629H10.7124ZM9.80568 9.80568L9.48995 10.0771C8.53417 10.8987 7.29483 11.3925 5.94625 11.3925C2.93824 11.3925 0.5 8.95428 0.5 5.94625C0.5 2.93824 2.93824 0.5 5.94625 0.5C8.95428 0.5 11.3925 2.93824 11.3925 5.94625C11.3925 7.29483 10.8987 8.53417 10.0771 9.48995L9.80568 9.80568ZM1.32962 5.94625C1.32962 8.50027 3.39224 10.5629 5.94625 10.5629C8.50027 10.5629 10.5629 8.50027 10.5629 5.94625C10.5629 3.39224 8.50027 1.32962 5.94625 1.32962C3.39224 1.32962 1.32962 3.39224 1.32962 5.94625Z"
        fill="#064C9B"
        stroke="#064C9B"
      />
    </svg>
  )
}

export const ClearIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="4"
        y1="4"
        x2="12"
        y2="12"
        stroke="#212121"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="4"
        x2="4"
        y2="12"
        stroke="#212121"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  )
}

export const RestoreIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.12508 0.749939C4.88078 0.749939 2.25008 3.38063 2.25008 6.62494H0.291748L2.90286 9.22952L5.51397 6.62494H3.55564C3.55564 4.09869 5.59883 2.05549 8.12508 2.05549C10.6513 2.05549 12.6945 4.09869 12.6945 6.62494C12.6945 9.15119 10.6513 11.1944 8.12508 11.1944C6.86522 11.1944 5.72286 10.6787 4.90036 9.84966L3.97341 10.7766C5.03744 11.8406 6.49966 12.4999 8.12508 12.4999C11.3694 12.4999 14.0001 9.86924 14.0001 6.62494C14.0001 3.38063 11.3694 0.749939 8.12508 0.749939ZM7.4723 4.01383V7.27772L10.2466 8.92272L10.7492 8.08716L8.45147 6.72286V4.01383H7.4723Z"
        fill="#8C8C8C"
      />
    </svg>
  )
}

export const ClearSmallIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.66745 0.471277C4.39813 0.15709 5.17564 0 6 0C6.82436 0 7.60187 0.15709 8.33255 0.471277C9.06324 0.785463 9.70023 1.21453 10.2436 1.7585C10.7869 2.30246 11.2155 2.93786 11.5293 3.66471C11.8431 4.39156 12 5.16764 12 5.99296C12 6.82767 11.8431 7.60844 11.5293 8.33529C11.2155 9.06214 10.7869 9.69754 10.2436 10.2415C9.70023 10.7855 9.06324 11.2145 8.33255 11.5287C7.60187 11.8429 6.82436 12 6 12C5.17564 12 4.39813 11.8429 3.66745 11.5287C2.93676 11.2145 2.29977 10.7855 1.75644 10.2415C1.21311 9.69754 0.784545 9.06214 0.470726 8.33529C0.156907 7.60844 0 6.82767 0 5.99296C0 5.16764 0.156907 4.39156 0.470726 3.66471C0.784545 2.93786 1.21311 2.30246 1.75644 1.7585C2.29977 1.21453 2.93676 0.785463 3.66745 0.471277ZM7.85479 8.80658L8.79624 7.86403L6.94144 5.99298L8.79624 4.13601L7.85479 3.19345L5.99999 5.05043L4.14519 3.19345L3.20374 4.13601L5.05854 5.99298L3.20374 7.86403L4.14519 8.80658L5.99999 6.93554L7.85479 8.80658Z"
        fill="#8C8C8C"
      />
    </svg>
  )
}

export const CloseModalIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.15" cx="20" cy="20" r="20" fill="white" />
      <path
        d="M18.1895 19.6895L20.3105 21.8105L15.8105 26.3105L18.5 29H11V21.5L13.6895 24.1895L18.1895 19.6895Z"
        fill="white"
      />
      <path d="M21.5 11H29V18.5H21.5V11Z" fill="white" />
    </svg>
  )
}

export const CloseTooltipModalIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.88993 0.628369C5.86417 0.209453 6.90085 0 8 0C9.09915 0 10.1358 0.209453 11.1101 0.628369C12.0843 1.04728 12.9336 1.61938 13.6581 2.34466C14.3825 3.06995 14.9539 3.91715 15.3724 4.88628C15.7908 5.85542 16 6.89019 16 7.99062C16 9.10356 15.7908 10.1446 15.3724 11.1137C14.9539 12.0829 14.3825 12.93 13.6581 13.6553C12.9336 14.3806 12.0843 14.9527 11.1101 15.3716C10.1358 15.7905 9.09915 16 8 16C6.90085 16 5.86417 15.7905 4.88993 15.3716C3.91568 14.9527 3.06636 14.3806 2.34192 13.6553C1.61748 12.93 1.04606 12.0829 0.627635 11.1137C0.209209 10.1446 0 9.10356 0 7.99062C0 6.89019 0.209209 5.85542 0.627635 4.88628C1.04606 3.91715 1.61748 3.06995 2.34192 2.34466C3.06636 1.61938 3.91568 1.04728 4.88993 0.628369ZM10.473 11.7421L11.7283 10.4854L9.25521 7.99065L11.7283 5.51468L10.473 4.25794L7.99995 6.73391L5.52688 4.25794L4.27161 5.51468L6.74467 7.99065L4.27161 10.4854L5.52688 11.7421L7.99995 9.2474L10.473 11.7421Z"
        fill="#D1D1D1"
      />
    </svg>
  )
}

export const RadioOff = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8.5" fill="white" stroke="#BABABA" />
    </svg>
  )
}

export const RadioOn = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="8.5" fill="white" stroke="#1B3963" />
      <circle cx="8.99998" cy="9.00001" r="5.4" fill="#1B3963" />
    </svg>
  )
}

interface PowerOffProps {
  size?: number
  color?: string
  opacity?: number
  className?: string
}

export const PowerOff = ({
  size = 24,
  color = 'white',
  opacity = 0.6,
  className,
}: PowerOffProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g opacity={opacity}>
        <path
          d="M13.1111 2H10.8889V13.1111H13.1111V2ZM18.4778 4.41111L16.9 5.98889C18.6556 7.4 19.7778 9.56667 19.7778 12C19.7778 16.3 16.3 19.7778 12 19.7778C7.7 19.7778 4.22222 16.3 4.22222 12C4.22222 9.56667 5.34444 7.4 7.08889 5.97778L5.52222 4.41111C3.36667 6.24444 2 8.95556 2 12C2 17.5222 6.47778 22 12 22C17.5222 22 22 17.5222 22 12C22 8.95556 20.6333 6.24444 18.4778 4.41111Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export const ExpandIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <path
          d="M2.90918 12L16.5455 12"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M13.8184 16.5455L18.3638 12L13.8184 7.45459"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <line x1="22" y1="2" x2="22" y2="22" stroke="white" strokeWidth="2" />
      </g>
    </svg>
  )
}

export const ExpandFilterIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.6">
        <path
          d="M2.90918 12L16.5455 12"
          stroke="#474747"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M13.8184 16.5455L18.3638 12L13.8184 7.45459"
          stroke="#474747"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <line x1="22" y1="2" x2="22" y2="22" stroke="#474747" strokeWidth="2" />
      </g>
    </svg>
  )
}

export const ActiveToggleIcon = () => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="12" rx="6" fill="#1B3963" />
      <circle cx="18" cy="6" r="4.5" fill="white" />
    </svg>
  )
}

export const InActiveToggleIcon = () => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="12" rx="6" fill="#D1D1D1" />
      <ellipse
        cx="5.88682"
        cy="6.00003"
        rx="4.5283"
        ry="4.61538"
        fill="white"
      />
    </svg>
  )
}

export const ActiveRiskToggleIcon = () => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="12" rx="6" fill="#1B3963" />
      <circle cx="18" cy="6" r="4.5" fill="white" />
    </svg>
  )
}

export const ActiveRecognizeToggleIcon = () => {
  return (
    <svg
      width="24"
      height="12"
      viewBox="0 0 24 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="12" rx="6" fill="#1B3963" />
      <ellipse
        cx="5.88682"
        cy="6.00003"
        rx="4.5283"
        ry="4.61538"
        fill="white"
      />
    </svg>
  )
}

export const MenuMobileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 17H20V14.6667H0V17ZM0 11.1667H20V8.83333H0V11.1667ZM0 3V5.33333H20V3H0Z"
        fill="#E8EBEF"
      />
    </svg>
  )
}

export const SearchMobileIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2939 12.5786H13.3905L13.0703 12.2699C14.191 10.9663 14.8656 9.27387 14.8656 7.43282C14.8656 3.32762 11.538 0 7.43282 0C3.32762 0 0 3.32762 0 7.43282C0 11.538 3.32762 14.8656 7.43282 14.8656C9.27387 14.8656 10.9663 14.191 12.2699 13.0703L12.5786 13.3905V14.2939L18.2962 20L20 18.2962L14.2939 12.5786ZM7.43282 12.5786C4.58548 12.5786 2.28702 10.2802 2.28702 7.43282C2.28702 4.58548 4.58548 2.28702 7.43282 2.28702C10.2802 2.28702 12.5786 4.58548 12.5786 7.43282C12.5786 10.2802 10.2802 12.5786 7.43282 12.5786Z"
        fill="#E8EBEF"
      />
    </svg>
  )
}

export const PortfolioIconMobile = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.9824 12.64C22.0082 12.514 22.0056 12.3838 21.9747 12.259C21.9438 12.1341 21.8853 12.0177 21.8037 11.9181C21.722 11.8186 21.6192 11.7384 21.5025 11.6833C21.3859 11.6283 21.2585 11.5998 21.1295 11.6H10.4349C10.2344 11.6002 10.0399 11.5313 9.8844 11.405C9.72895 11.2786 9.62211 11.1026 9.58199 10.9067L9.34028 9.69333C9.30016 9.49743 9.19332 9.32138 9.03787 9.19502C8.88242 9.06866 8.68791 8.99976 8.48732 9H2.87052C2.7415 8.99985 2.61406 9.02831 2.49745 9.08334C2.38084 9.13836 2.27797 9.21857 2.19631 9.31813C2.11465 9.4177 2.05625 9.53413 2.02533 9.65899C1.99442 9.78385 1.99176 9.914 2.01757 10.04L4.2782 21.3067C4.31832 21.5026 4.42516 21.6786 4.58061 21.805C4.73606 21.9313 4.93056 22.0002 5.13115 22H19.3905C19.591 22 19.7853 21.9311 19.9405 21.8047C20.0958 21.6784 20.2025 21.5024 20.2426 21.3067L21.9824 12.64Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7V8H7V7H5ZM6.93333 2V1V2ZM19 10V11H21V10H19ZM7 7V2.75H5V7H7ZM7 2.75C7 2.89569 6.9265 2.97769 6.89976 2.99918L5.64698 1.44016C5.27017 1.74295 5 2.20649 5 2.75H7ZM6.89976 2.99918C6.88717 3.00929 6.88311 3.00886 6.89198 3.00591C6.90053 3.00306 6.91501 3 6.93333 3V1C6.4828 1 6.01802 1.142 5.64698 1.44016L6.89976 2.99918ZM6.93333 3H19.0667V1H6.93333V3ZM19.0667 3C19.085 3 19.0995 3.00306 19.108 3.00591C19.1169 3.00886 19.1128 3.00929 19.1002 2.99918L20.353 1.44016C19.982 1.142 19.5172 1 19.0667 1V3ZM19.1002 2.99918C19.0735 2.97769 19 2.89569 19 2.75H21C21 2.20649 20.7298 1.74296 20.353 1.44016L19.1002 2.99918ZM19 2.75V10H21V2.75H19Z"
        fill="white"
      />
      <path
        d="M9.31836 4.72729H16.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M12.5 7.45447H16.545"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  )
}

export const SupportMobileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM20.206 8.832L17.148 10.097C16.587 8.601 15.41 7.413 13.903 6.863L15.168 3.805C17.478 4.685 19.315 6.522 20.206 8.832ZM12 15.3C10.174 15.3 8.7 13.826 8.7 12C8.7 10.174 10.174 8.7 12 8.7C13.826 8.7 15.3 10.174 15.3 12C15.3 13.826 13.826 15.3 12 15.3ZM8.843 3.794L10.13 6.852C8.612 7.402 7.413 8.601 6.852 10.119L3.794 8.843C4.685 6.522 6.522 4.685 8.843 3.794ZM3.794 15.157L6.852 13.892C7.413 15.41 8.601 16.598 10.119 17.148L8.832 20.206C6.522 19.315 4.685 17.478 3.794 15.157ZM15.168 20.206L13.903 17.148C15.41 16.587 16.598 15.399 17.148 13.881L20.206 15.168C19.315 17.478 17.478 19.315 15.168 20.206Z"
        fill="white"
      />
    </svg>
  )
}

export const ArrowDownIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 4.66663L8 10.6666L14 4.66663"
        stroke="#757575"
        strokeWidth="2"
      />
    </svg>
  )
}

export const TrashMobileIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M2.66672 14.2222C2.66672 15.1999 3.46671 15.9999 4.44449 15.9999H11.5556C12.5333 15.9999 13.3333 15.1999 13.3333 14.2222V3.55554H2.66672V14.2222ZM4.44449 5.33331H11.5556V14.2222H4.44449V5.33331ZM11.1111 0.888885L10.2222 0H5.77781L4.88893 0.888885H1.77783V2.66665H14.2222V0.888885H11.1111Z"
          fill="#DE3131"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const FilterMobileIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.22222 13.3333H9.77778V11.5556H6.22222V13.3333ZM0 2.66666V4.44444H16V2.66666H0ZM2.66667 8.88889H13.3333V7.11111H2.66667V8.88889Z"
        fill="#1B3963"
      />
    </svg>
  )
}

export const RefreshMobileIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M7.7001 1.2L8.4001 7.6L10.5001 5.5C12.4001 7.4 12.4001 10.6 10.5001 12.5C9.6001 13.5 8.3001 14 7.0001 14C5.7001 14 4.4001 13.5 3.5001 12.5C1.6001 10.6 1.6001 7.4 3.5001 5.5C4.1001 4.9 4.9001 4.4 5.8001 4.2L5.2001 2.3C4.0001 2.6 2.9001 3.2 2.0001 4.1C-0.699902 6.8 -0.699902 11.2 2.0001 14C3.3001 15.3 5.1001 16 6.9001 16C8.8001 16 10.5001 15.3 11.8001 14C14.5001 11.3 14.5001 6.9 11.8001 4.1L14.0001 1.9L7.7001 1.2Z"
          fill="#1B3963"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
